import { BaseModel } from "model/BaseModel";

export default class Feriado implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    data: Date | null;
    replicaAnualmente: boolean;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        data = null,
        replicaAnualmente = false,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.data = data;
        this.replicaAnualmente = replicaAnualmente;
    }
}
